import { all, takeLatest, put, call, select } from "typed-redux-saga/macro";

import {
  signInFailed,
  signOutFailed,
  signOutSuccess,
  SignUpSuccess,
} from "./user.action";

import { USER_ACTION_TYPES } from "./user.types";
import { userActions } from "./user.slice";
import { User } from "utils/types/user";
import { hostURL, USER_TOKEN } from "utils/helper/states";
import { websocketService } from "services/websocketService";
import { apiRequest } from "utils/helper/helper";
import { RootState } from "store/store";

export function* getSnapshotFromUserAuth(
  user: User
  //additionalInformation
) {
  try {
    yield* put(userActions.setCurrentUser(user));
    yield* put(userActions.setIsLoggedIn(true));
  } catch (error) {
    yield* put(signInFailed(error as Error));
  } finally {
    yield* put(userActions.setIsLoading(false));
  }
}

export function* signInAfterSignUp({ payload: user }: SignUpSuccess) {
  try {
    yield* call(getSnapshotFromUserAuth, user);
  } catch (error) {
    yield* put(signInFailed(error as Error));
  }
}

export function* fetchUserNotifications() {
  try {
    const user = yield* select((state: RootState) => state.user);
    const uri = hostURL + "/api/notifications/get-notifications";
    const data = yield* call(apiRequest, uri, user.currentUser?.token);

    if (!data) return;
    yield* put(userActions.setNotifications(data));
  } catch (error) {
    console.log(error as Error);
  }
}

// export function* isUserAuthenticated() {
//   try {
//     const userAuth = yield* call(getCurrentUser);
//     if (!userAuth) return;
//     yield* call(getSnapshotFromUserAuth, userAuth);
//   } catch (error) {
//     yield* put(signInFailed(error as Error));
//   }
// }

export function* signOut() {
  try {
    // yield* call(signOutUser);
    yield* put(userActions.logout(true));
    yield* put(signOutSuccess());
  } catch (error) {
    yield* put(signOutFailed(error as Error));
  }
}

// export function* onEmailSignInStart() {
//   yield* takeLatest(
//     USER_ACTION_TYPES.EMAIL_SIGN_IN_START,
//     signInWithEmailAndPassord
//   );
// }

export function* onGoogleSignInStart() {
  // yield* takeLatest(USER_ACTION_TYPES.GOOGLE_SIGN_IN_START, signInWithGoogle);
}

export function* onSignUpStart() {
  // yield* takeLatest(USER_ACTION_TYPES.USER_SIGN_UP_START, userSignUp);
}

export function* onSignUpSuccess() {
  yield* takeLatest(USER_ACTION_TYPES.SIGN_UP_SUCCESS, signInAfterSignUp);
}

export function* onCheckUserSession() {
  // yield* takeLatest(USER_ACTION_TYPES.CHECK_USER_SESSION, isUserAuthenticated);
}

export function* onSignOutStart() {
  yield* takeLatest(USER_ACTION_TYPES.SIGN_OUT_START, signOut);
}
export function* onFetchUserNotifications() {
  yield* takeLatest(
    USER_ACTION_TYPES.FETCH_NOTIFICATIONS,
    fetchUserNotifications
  );
}

export function* userSagas() {
  yield* all([
    call(onCheckUserSession),
    call(onGoogleSignInStart),
    call(onFetchUserNotifications),
    call(onSignUpStart),
    call(onSignUpSuccess),
    call(onSignOutStart),
  ]);
}
